// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateStreamModal_wrapper__5ZxWw","image":"CreateStreamModal_image__1ECSC"};